export default "<h1 class=\"page-title\">Rye</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";